import { Result } from "../../../models/Result";
import { httpService } from "../../HttpService";

import { RollbackDepositRequestModel } from "../../../models/RollbackDepositRequestModel";
import { TransactionReversalCheckResponse } from "../../../models/TransactionReversalCheckResponse";

class IndividualPaymentApiService {

    private baseCrmUrl: string = process.env.REACT_APP_CRM_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL ?? '';

    private individualPaymentApiUrl: string = `${this.baseCrmUrl}/IndividualPayment`;

    private rollbackDepositEndpoint: string = 'rollback-deposit';
    private isTransactionReversedEndpoint: string = 'is-transaction-reversed';

    rollbackDeposit = async (model: RollbackDepositRequestModel): Promise<Result<string>> =>
        await httpService.post<string>(`${this.individualPaymentApiUrl}/${this.rollbackDepositEndpoint}`, model);

    isTransactionReversed = async (flexCubeTransactionReference: string): Promise<Result<TransactionReversalCheckResponse>> =>
        await httpService.get<TransactionReversalCheckResponse>(`${this.individualPaymentApiUrl}/${this.isTransactionReversedEndpoint}/${flexCubeTransactionReference}`);
}

const individualPaymentApiService = new IndividualPaymentApiService();

export { individualPaymentApiService };
